// Un AP/EA cargado en la visita actual puede llegar dos veces mientras coexisten sus dos fuentes: una vez
// desde el formulario de la visita en curso (con fecha, ver VisitsController.GetAdverseEvents) y otra vez,
// si ya fue sincronizado antes, desde el registro persistido en Historia Clínica (getAdverseEvents/
// getPersonalHistories). Como ambas fuentes ya exponen fromYear/fromMonth/fromDay, se puede deduplicar por
// contenido exacto (mismo concepto + misma fecha desde) en vez de por conteo de "con fecha vs sin fecha".
// El último en pisar la clave gana -- el registro persistido llega después en el array y tiene prioridad
// sobre la copia todavía-no-sincronizada del formulario.
export const dedupeAdverseEventsByConceptAndDate = items => {
    const byKey = new Map();
    (items || []).forEach(item => {
        const key = `${item.conceptId}|${item.fromYear}|${item.fromMonth}|${item.fromDay}`;
        byKey.set(key, item);
    });
    return Array.from(byKey.values());
};
